export const QA_NAME_EDIT_TYPE_MODAL = 'editType'

export const TASK_EDIT_TYPE_FIELDS_FIELD_NAME = 'type_id'

export const TASK_EDIT_TYPE_FIELDS_INITIAL_VALUES = {
  [TASK_EDIT_TYPE_FIELDS_FIELD_NAME]: null,
}
